import React, { Fragment,useEffect,useRef,useState } from "react";
import DrawingManager from 'react-google-maps/lib/components/drawing/DrawingManager'
import { useSelector, useDispatch } from 'react-redux';
import {  DichChuyenDuong } from "../../Containers/GiaoCatPolygons";
import Type from "../../Redux/Type";
import { Polygon, Polyline } from "react-google-maps";

const Drawing = props => {
    const { modeChosen,drawingMode, listPoints, listLine,   textInputLoGioi } = useSelector(state => state.drawingTool);
    const dispatch = useDispatch();
    const drawingMain = useRef()
    const polygonMain = useRef()
    const polyLineMain = useRef()
    const onPolygonComplete = (event) => {
        dispatch({ type: Type.SET_EVT_DRAWING, evt: event });
        dispatch({ type: Type.STOP_DRAWING })
    };

    const onRectangleComplete = (event) => {
        let bounds = event.getBounds()
        var areaBounds = {
            north: bounds.getNorthEast().lat(),
            south: bounds.getSouthWest().lat(),
            east: bounds.getNorthEast().lng(),
            west: bounds.getSouthWest().lng()
        };

        let topRight = { lat: areaBounds['north'], lng: areaBounds['east'] }
        let topLeft = { lat: areaBounds['north'], lng: areaBounds['west'] }
        let botRight = { lat: areaBounds['south'], lng: areaBounds['east'] }
        let botLeft = { lat: areaBounds['south'], lng: areaBounds['west'] }
        event.paths = [topLeft, topRight, botRight, botLeft]

        dispatch({ type: Type.SET_EVT_DRAWING, evt: event });
        dispatch({ type: Type.STOP_DRAWING })
    };
    const onCircleComplete = (event) => {

        dispatch({ type: Type.SET_EVT_DRAWING, evt: event });
        dispatch({ type: Type.STOP_DRAWING })
    };
    
    const onPolygonDragEnd = (evt) =>{
        
    }

    const onPolygonEdited = (evt)=>{
        let strNew = ""
        let count = polygonMain.current.getPath().getArray().length
        let newArr =  polygonMain.current.getPath().getArray().map((e,index)=>{
            strNew += index === count -1 ?  `(${e.lat()},${e.lng()})` : `(${e.lat()},${e.lng()}) | `
            return {lat: e.lat(), lng: e.lng()}
        })
        dispatch({ type: Type.SET_DRAWING_TEXT_INPUT,evt: strNew })
        dispatch({ type: Type.SET_DRAWING_POINT,evt: newArr })
    }

    const onPolylineEdited = (evt) => {
        let strNew = ""
        let count = polyLineMain.current.getPath().getArray().length
        let newArr =  polyLineMain.current.getPath().getArray().map((e,index)=>{
            strNew += index === count -1 ?  `(${e.lat()},${e.lng()})` : `(${e.lat()},${e.lng()}) | `
            return [ e.lat(), e.lng()]
        })
        dispatch({ type: Type.SET_DRAWING_TEXT_INPUT,evt: strNew })
        let line1 =    DichChuyenDuong(newArr,textInputLoGioi/2)
        let line2 =    DichChuyenDuong(newArr,textInputLoGioi/2 * -1)
        line2 = line2.reverse();
        line1 = line1.concat(line2)
        let arrToaDoN =  line1.map(e=>{
          return {lat: e[0] , lng: e[1]}
        })
        dispatch({ type: Type.SET_DRAWING_POINT,evt: [] })
        dispatch({ type: Type.SET_DRAWING_POINT,evt: arrToaDoN })
    }
    try {
        return (
            <Fragment>
                {
                    modeChosen !== 'nangcao' ?
    
                        <DrawingManager
                            // defaultDrawingMode={'overlaycomplete'}
                            ref={drawingMain}
                            defaultOptions={{
                                drawingControl: false,
                                polygonOptions: {
                                    fillColor: `#ffff00`,
                                    fillOpacity: .3,
                                    strokeWeight: 2,
                                    clickable: true,
                                    editable: true,
                                    zIndex: 999,
                                    draggable: true,
                                },
                                circleOptions: {
                                    fillColor: `#ffff00`,
                                    fillOpacity: .3,
                                    strokeWeight: 2,
                                    clickable: true,
                                    editable: true,
                                    zIndex: 999,
                                    draggable: true,
                                },
                                rectangleOptions: {
                                    fillColor: `#ffff00`,
                                    fillOpacity: .3,
                                    strokeWeight: 2,
                                    clickable: true,
                                    editable: true,
                                    zIndex: 999,
                                    draggable: true,
                                },
                            }
                            }
    
                            onRectangleComplete={onRectangleComplete}
                            onCircleComplete={onCircleComplete}
                            drawingMode={drawingMode}
                            onPolygonComplete={onPolygonComplete}
                        />
                        : 
                        listPoints.length > 0 ?
                            <Polygon
                                ref={polygonMain}
                                paths={listPoints}
                                defaultPath={[]}
                                options={{
                                    fillColor: `#ffff00`,
                                    fillOpacity: .3,
                                    strokeWeight: 2,
                                    clickable: listLine.length > 0 ? false : true,
                                    editable: listLine.length > 0 ? false : true,
                                    zIndex: 999,
                                    draggable: listLine.length > 0 ? false : true,
                                }}
                                // draggable={listLine.length > 0 ? false : true}
                                onDragEnd={onPolygonDragEnd}
                                onMouseUp={onPolygonEdited}
                                // editable={ listLine.length > 0 ? false : true}
                            /> : null
                }
                {
                    listLine.length > 0 ? 
                    <Polyline
                        ref={polyLineMain}
                        editable={true}
                        key={'linequyhoach111'}
                        path={listLine}
                        options={{
                            strokeColor: 'red',
                            strokeWeight: 1,
                            zIndex: 500
                        }}
                        onMouseUp={onPolylineEdited}
                        onClick={()=>{}}
                    /> : null
                }
            </Fragment>
        )
    } catch (error) {
        alert('Lỗi khi thực hiện vẽ quy hoạch, do dữ liệu điểm không đúng')
    }
   
}

export default Drawing
